import { createNativeComponentRender as createNativeComponentRenderImpl } from './native/createNativeComponentFactory';
import { track } from '../tracking';
import { withAdResponseReceivedEvent, withAdLoadedEvent } from '../tracking/events';

var renderNativeAd = function renderNativeAd(adSpot, content, createNativeComponentRender, shouldTrackEvent) {
  adSpot.nativeType = 'json';
  adSpot.nativeContent = content;
  adSpot.cleanup();

  if (adSpot.nativeRenderCallback) {
    if (typeof adSpot.nativeRenderCallback !== 'function') {
      return Promise.reject(new Error('Custom native renderer callback is not a function'));
    }

    adSpot.nativeRenderCallback(content, adSpot.element);
    return Promise.resolve('loaded native ad in nativeRenderCallback');
  }

  if (!adSpot.isAdLoaded()) {
    return Promise.reject(new Error('native basic ad not loaded'));
  }

  var adLoaded = true;
  var nativeComponentRenderer = createNativeComponentRender(content.adtype);
  return nativeComponentRenderer.render(content, adSpot.element, adSpot).then(function () {
    if (typeof adSpot.loadCompleteCallback === 'function') {
      adSpot.loadCompleteCallback(content, adLoaded);
    }

    track(withAdLoadedEvent(), adSpot, shouldTrackEvent);
    return 'Loaded native ad in native template render';
  });
};

export default (function () {
  var createNativeComponentRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : createNativeComponentRenderImpl;
  var shouldTrackEvent = arguments.length > 1 ? arguments[1] : undefined;
  return function (adSpot, response) {
    var contentType = response.contentType,
        content = response.content;
    var eventProperties = {
      adResponseContentType: contentType,
      fcid: content.fcid,
      jsonResponseAdType: content.adtype
    };
    track(withAdResponseReceivedEvent(eventProperties), adSpot, shouldTrackEvent);
    return renderNativeAd(adSpot, content, createNativeComponentRender, shouldTrackEvent);
  };
});
//# sourceMappingURL=createJsonAdHandler.js.map